import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Guide.module.scss';

export const GuideMainSection = () => (
  <WorkPageLayout
    isMain
    leftContent={
      <div className={styles.guideLeftSection}>
        <span className={styles.guideMain_1}>The</span>
        <span className={styles.guideMain_2}>Guide</span>
        <span className={styles.guideMain_3}>to a sustainable</span>
        <span className={styles.guideMain_4}>technological</span>
        <span className={styles.guideMain_5}>future</span>
      </div>
    }
    rightContent={null}
  />
);
